module.exports = __webpack_public_path__ + "img/lg_ring_y_l_null_0.ad16d73f.png";